module.exports = __webpack_public_path__ + "img/left-mid.aaa92398.png";